import api from '@pray/shared/utils/api';

/**
 * @param {{
 *   artistId?: string | null,
 *   contentId?: string | null,
 *   locale?: string | null,
 *   version?: number,
 *   type?: string,
 *   force?: boolean,
 *   tasks?: string[],
 *   instructions?: string,
 * }} options
 */
export async function triggerWorkflowAIForContent({
  artistId = null,
  contentId = null,
  locale = null,
  version = 1,
  type = 'full-content',
  force = undefined,
  tasks = undefined,
  instructions = undefined,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const normalizedInstructions = instructions?.trim();
  const data = {
    type,
    version,
    ...(typeof force === 'boolean' ? { force } : {}),
    ...(tasks?.length ? { tasks } : {}),
    ...(normalizedInstructions ? { instructions: normalizedInstructions } : {}),
  };

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/workflow-ai`;
  const response = await api.executePostRequest(url, data);

  return response.data.data;
}
